const isPlainObject = (value) => (
  value != null && typeof value === 'object' && !Array.isArray(value)
);

const joinParts = (parts) => parts.filter((part) => part != null && part !== '').join(' — ');

export const formatAggregatedInputValue = (value) => {
  if (value == null) return '';
  if (typeof value !== 'object') return String(value);

  if (Array.isArray(value)) {
    return value.map((item) => formatAggregatedInputValue(item)).filter(Boolean).join(', ');
  }

  if (!isPlainObject(value)) return String(value);

  const name = value.name ?? value.title ?? value.text;
  const { url, currency } = value;
  const amount = value.value;

  if (name != null || url != null) {
    return joinParts([name, url]);
  }

  if (amount != null || currency != null) {
    return joinParts([amount, currency]);
  }

  try {
    return JSON.stringify(value);
  } catch (error) {
    return '';
  }
};

export default formatAggregatedInputValue;
